import {
  Typography,
  Grid,
} from "@mui/material";
import { formatMoney } from "../../utils/utils";

//
// ################################################################################
//
const PrecioVentaContadoLista = ({ precioVentaContado, precioVentaLista }) => (
  <>
    <Typography variant="h6" gutterBottom sx={{ mt: 1, mb: 2 }}>
      Precios
    </Typography>

    <Grid container spacing={3} sx={{ mb: 2 }}>
      <Grid item xs={12} sm={6}>
        <Typography variant="body2" color="text.secondary">
          Precio venta contado
        </Typography>
        <Typography variant="h5" fontWeight="bold">
          {precioVentaContado ? `$ ${formatMoney(precioVentaContado)}` : "Precio no disponible"}
        </Typography>
      </Grid>

      <Grid item xs={12} sm={6}>
        <Typography variant="body2" color="text.secondary">
          Precio venta lista
        </Typography>
        <Typography variant="h5" fontWeight="bold">
          {precioVentaLista ? `$ ${formatMoney(precioVentaLista)}` : "Precio no disponible"}
        </Typography>
      </Grid>
    </Grid>
  </>
);
export default PrecioVentaContadoLista;